module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_tennis-80cab96a98b51218466b2a2bf164802b.mp4";